import i18n from '@cashew/i18n';
import chargeback from './chargeback/ar';
import contactUs from './contactUs/ar';
import customerDetails from './customerDetails/ar';
import customer from './customers/ar';
import dispatches from './dispatches/ar';
import disputes from './disputes/ar';
import errors from './errors/ar';
import home from './home/ar';
import merchantOnboarding from './merchantOnboarding/ar';
import merchants from './merchants/ar';
import months from './months/ar';
import notAuthorized from './notAuthorized/ar';
import notFound from './notFound/ar';
import notificationDetails from './notificationDetails/ar';
import notifications from './notifications/ar';
import onboarding from './onboarding/ar';
import outstanding from './outstanding/ar';
import payment from './payment/ar';
import refunds from './refunds/ar';
import settings from './settings/ar';
import settlementDetails from './settlementDetails/ar';
import settlements from './settlements/ar';
import subscriptionHistory from './subscriptionHistory/ar';
import transactions from './transactions/ar';
import transactionsList from './transactionsList/ar';
import validationModal from './validationModal/ar';

export default {
  ...i18n.ar,
  'status.DISPATCHED': 'Dispatched',
  'status.APPROVED': 'Approved',
  'status.DISBURSED': 'Disbursed',
  'status.RECEIVED': 'Received',
  'filed.empty': '-',
  ...errors,
  ...home,
  ...payment,
  ...notifications,
  ...notificationDetails,
  ...dispatches,
  ...settlements,
  ...outstanding,
  ...refunds,
  ...merchants,
  ...merchantOnboarding,
  ...disputes,
  ...subscriptionHistory,
  ...transactions,
  ...transactionsList,
  ...onboarding,
  ...contactUs,
  ...notAuthorized,
  ...notFound,
  ...months,
  ...settlementDetails,
  ...customerDetails,
  ...customer,
  ...validationModal,
  ...settings,
  ...chargeback,
};
